function PutNuovaDomanda() {

    try {
        if (IsUserLogged() == false) {
            $("#popuplogin").dxPopup("show");
        }
        else {
            waitingBS.Show();
            var formData = new FormData($('#fchiediauncollga')[0]);

            mainController.CallServiceFormDataAsync($('#fchiediauncollga').attr('action'), formData)
                .then(r => {
                    mainController.NotifyMessageTimed(r.responseText, r.NotifyColor, 3500);

                    $('#testo').val('');

                    waitingBS.Hide();
                })
                .catch(err => {
                    console.log(err);
                    mainController.NotifyMessageTimed(mainController.GetLabel('lErroreGenerico'), Costanti.NOTIFY_COLOR_ERROR, 3500);
                    waitingBS.Hide();
                });
        }

    }
    catch (error) {
        console.log(error);
        waitingBS.Hide();
    }
    return false;
}

function CheckLogged(elem) {
    try {
        if (IsUserLogged() == false && $(elem).val().trim().length > 0) {
            $(elem).val('');
            $("#popuplogin").dxPopup("show");
        }
    } catch (error) {
        console.log(error);
    }
}